import {getGlobalIdentifier} from './GlobalRetriever';

const prefixIdentifier = getGlobalIdentifier();

// retrieves item from local storage
const getFromLocalStorage = (name, isPromise) => {
    const prefixedVar = prefixIdentifier + name;

    if (isPromise === true) {
        return new Promise((resolve, reject) => {
            const item = localStorage.getItem(prefixedVar);
            if (item) {
                try {
                    resolve(JSON.parse(item))
                } catch (e) {
                    if (process.env.NODE_ENV === 'development') console.warn('[SettingsRetriever] Could not get item ' + name + ': ', e)
                    resolve(item);
                }
            } else {
                if (process.env.NODE_ENV === 'development') console.warn('[SettingsRetriever] Could not get item ' + name)
                reject(false);
            }
        })
    } else {
        const item = localStorage.getItem(prefixedVar);
        if (item) {
            try {
                return JSON.parse(item);
            } catch (e) {
                if (process.env.NODE_ENV === 'development') console.warn('[SettingsRetriever] Could not get item ' + name + ': ', e)
                return item;
            }
        } else {
            if (process.env.NODE_ENV === 'development') console.warn('[SettingsRetriever] Could not get item ' + name)
            return false;
        }
    }
}

// saves item in local storage
const setToLocalStorage = (name, settings) => {
    const prefixedVar = prefixIdentifier + name;

    try {
        const aux = JSON.stringify(settings);
        localStorage.setItem(prefixedVar, aux);
        return true;
    } catch (e) {
        if (process.env.NODE_ENV === 'development') console.warn('[SettingsRetriever] Could not persist ' + name + ' item: ', e);
        return false;
    }
}

// gets system settings as an object
const getSystemSettings = (isPromise = false) => {
    return getFromLocalStorage('system', isPromise);
}

// stores system settings as a string in local storage
const setSystemSettings = (settings) => {
    return setToLocalStorage('system', settings);
}

// gets the customer config
const getCustomerConfig = (isPromise = false) => {
    return getFromLocalStorage('config', isPromise);
}

// stores customer config as a string in local storage
const setCustomerConfig = (settings) => {
    return setToLocalStorage('config', settings);
}

// gets the customer session id
const getSessionId = (isPromise = false) => {
    return getFromLocalStorage('sessionId', isPromise);
}

// stores customer session id as a string in local storage
const setSessionId = (settings) => {
    return setToLocalStorage('sessionId', settings);
}

// gets the spotlio session id
const getSpotlioSessionId = (isPromise = false) => {
    return getFromLocalStorage('spotlioSessionId', isPromise);
}

// stores spotlio session id as a string in local storage
const setSpotlioSessionId = (settings) => {
    return setToLocalStorage('spotlioSessionId', settings);
}

// gets the itinerary id
const getUserKey = (isPromise = false) => {
    return getFromLocalStorage('userKey', isPromise);
}

// stores customer spotlio id as a string in local storage
const setUserKey = (settings) => {
    return setToLocalStorage('userKey', settings);
}

// gets the itinerary id
const getItineraryId = (isPromise = false) => {
    return getFromLocalStorage('itineraryId', isPromise);
}

// stores itinerary id as a string in local storage
const setItineraryId = (settings) => {
    return setToLocalStorage('itineraryId', settings);
}

// gets the sort order
const getSortOrder = (isPromise = false) => {
    return getFromLocalStorage('sortOrder', isPromise);
}

// stores sort order as a string in local storage
const setSortOrder = (settings) => {
    return setToLocalStorage('sortOrder', settings);
}

// gets the form data
const getFormData = (isPromise = false) => {
    return getFromLocalStorage('formData', isPromise);
}

// stores form data as a string in local storage
const setFormData = (settings) => {
    return setToLocalStorage('formData', settings);
}

// gets the form data
const getFormDataLift = (isPromise = false) => {
    return getFromLocalStorage('formDataLift', isPromise);
}

// stores form data as a string in local storage
const setFormDataLift = (settings) => {
    return setToLocalStorage('formDataLift', settings);
}

// gets the form data
const getSelectedPromocode = (isPromise = false) => {
    return getFromLocalStorage('selectedPromocode', isPromise);
}

// stores form data as a string in local storage
const setSelectedPromocode = (settings) => {
    return setToLocalStorage('selectedPromocode', settings);
}

// gets the currency database
const getCurrencyDatabase = (isPromise = false) => {
    return getFromLocalStorage('CurrencyDatabase', isPromise);
}

// stores currency database as a string in local storage
const setCurrencyDatabase = (settings) => {
    return setToLocalStorage('CurrencyDatabase', settings);
}

// gets user settings as an object
const getUserSettings = (isPromise = false) => {
    return getFromLocalStorage('user', isPromise);
}

// stores user settings as a string in local storage
const setUserSettings = (settings) => {
    return setToLocalStorage('user', settings);
}

// gets payment method as an object
const getPaymentMethod = (isPromise = false) => {
    return getFromLocalStorage('paymentMethod', isPromise);
}

// stores payment method as a string in local storage
const setPaymentMethod = (settings) => {
    return setToLocalStorage('paymentMethod', settings);
}

// gets confirm errors as an object
const getConfirmErrors = (isPromise = false) => {
    return getFromLocalStorage('confirmErrors', isPromise);
}

// stores confirm errors as a string in local storage
const setConfirmErrors = (settings) => {
    return setToLocalStorage('confirmErrors', settings);
}

const getCartLength = (isPromise = false) => {
    return getFromLocalStorage('cartLength', isPromise);
}

// stores confirm errors as a string in local storage
const setCartLength = (length) => {
    return setToLocalStorage('cartLength', length);
}

// stores the current state of reset password component
const setResetPasswordState = (state) => {
    return setToLocalStorage('resetPassword', state);
}

// gets the current state of reset password component
const getResetPasswordState = (isPromise = false) => {
    return getFromLocalStorage('resetPassword', isPromise);
}

const getCheckoutState = (isPromise = false) => {
    return getFromLocalStorage('checkoutState', isPromise);
}

const setCheckoutState = (length) => {
    return setToLocalStorage('checkoutState', length);
}

const getLoginAttempts = (isPromise = false) => {
    return getFromLocalStorage('loginAttempts', isPromise);
}

const setLoginAttempts = (length) => {
    return setToLocalStorage('loginAttempts', length);
}

const getHideTopbar = (isPromise = false) => {
    return getFromLocalStorage('hideTopbar', isPromise);
}

const setHideTopbar = (length) => {
    return setToLocalStorage('hideTopbar', length);
}

const getSpotlioUserId = (isPromise = false) => {
    return getFromLocalStorage('SpotlioUserId', isPromise);
}

const setSpotlioUserId = (length) => {
    return setToLocalStorage('SpotlioUserId', length);
}

const getTimestamp = (isPromise = false) => {
    return getFromLocalStorage('timestamp', isPromise);
}

const setTimestamp = (time) => {
    return setToLocalStorage('timestamp', time);
}

const getCustomerToken = (isPromise = false) => {
    return getFromLocalStorage('customerToken', isPromise);
}

const setCustomerToken = (time) => {
    return setToLocalStorage('customerToken', time);
}

const setAutoModalTimeStamp = (time) => {
    return setToLocalStorage('autoModalTimeStamp', time);
}

const getAutoModalTimeStamp = (isPromise = false) => {
    return getFromLocalStorage ('autoModalTimeStamp', isPromise);
}

const setDestinationID = (time) => {
    return setToLocalStorage('destinationID', time);
}

const getDestinationID = (isPromise = false) => {
    return getFromLocalStorage ('destinationID', isPromise);
}

const setOneIDToken = (time) => {
    return setToLocalStorage('OneIDToken', time);
}

const getOneIDToken = (isPromise = false) => {
    return getFromLocalStorage ('OneIDToken', isPromise);
}

const setKoediaCartToken = (time) => {
    return setToLocalStorage('KoediaCartToken', time);
}

const getKoediaCartToken = (isPromise = false) => {
    return getFromLocalStorage ('KoediaCartToken', isPromise);
}

const setDestination = (destination) => {
    return setToLocalStorage('destination', destination);
}

const getDestination = (isPromise = false) => {
    return getFromLocalStorage ('destination', isPromise);
}

const setStoreModal = (time) => {
    return setToLocalStorage("storeModal", time);
} 

const getStoreModal = (isPromise = false) => {
    return getFromLocalStorage ('storeModal', isPromise);
}

const setLodgingFilters = (filters) => {
    return setToLocalStorage("lodgingFilters", filters);
}

const getLodgingFilters = (isPromise = false) => {
    return getFromLocalStorage("lodgingFilters", isPromise);
}

const setActivitiesFilters = (filters) => {
    return setToLocalStorage("activitiesFilters", filters);
}

const getActivitiesFilters = (isPromise = false) => {
    return getFromLocalStorage("activitiesFilters", isPromise);
}

const setSeason = (season) => {
    return setToLocalStorage("season", season);
}

const getSeason = (isPromise = false) => {
    return getFromLocalStorage("season", isPromise);
}

const setLoged = (loginStatus) => {
    return setToLocalStorage("login", loginStatus);
}

const getLoged = (isPromise = false) => {
    return getFromLocalStorage("login", isPromise);
}

const setLocale = (locale) => {
    return setToLocalStorage("locale", locale);
}

const getLocale = (isPromise = false) => {
    return getFromLocalStorage("locale", isPromise);
}

// gets the customer of the current session
const getCustomer = (isPromise = false) => {
    return getFromLocalStorage("customer", isPromise);
}

// sets the customer of the current session
const setCustomer = (customer) => {
    return setToLocalStorage("customer", customer);
}

const getCustomPhone = (isPromise = false) => {
    return getFromLocalStorage("phone", isPromise);
}

const setCustomPhone = (phone) => {
    return setToLocalStorage("phone", phone);
}

const getCartImages = (isPromise = false) => {
    return getFromLocalStorage("cartImages", isPromise);
}

const setCartImages = (images) => {
    return setToLocalStorage("cartImages", images);
}

const getOnlySupplier = (isPromise = false) => {
    return getFromLocalStorage("onlySupplier", isPromise);
}

const setOnlySupplier = (supplier) => {
    return setToLocalStorage("onlySupplier", supplier);
}

// export methods
export {
    getSystemSettings,
    setSystemSettings,
    getCustomerConfig,
    setCustomerConfig,
    getSessionId,
    setSessionId,
    getUserKey,
    setUserKey,
    getItineraryId,
    setItineraryId,
    getSortOrder,
    setSortOrder,
    getFormData,
    setFormData,
    getFormDataLift,
    setFormDataLift,
    getSelectedPromocode,
    setSelectedPromocode,
    getCurrencyDatabase,
    setCurrencyDatabase,
    getUserSettings,
    setUserSettings,
    getPaymentMethod,
    setPaymentMethod,
    getConfirmErrors,
    setConfirmErrors,
    getCartLength,
    setCartLength,
    setResetPasswordState,
    getResetPasswordState,
    getCheckoutState,
    setCheckoutState,
    getLoginAttempts,
    setLoginAttempts,
    getHideTopbar,
    setHideTopbar,
    getSpotlioUserId,
    setSpotlioUserId,
    setSpotlioSessionId,
    getSpotlioSessionId,
    getTimestamp,
    setTimestamp,
    getCustomerToken,
    setCustomerToken,
    setAutoModalTimeStamp,
    getAutoModalTimeStamp,
    setDestinationID,
    getDestinationID,
    setOneIDToken,
    getOneIDToken,
    setKoediaCartToken,
    getKoediaCartToken,
    getDestination,
    setDestination,
    setStoreModal,
    getStoreModal,
    setLodgingFilters,
    getLodgingFilters,
    setActivitiesFilters,
    getActivitiesFilters,
    setSeason,
    getSeason,
    setLoged,
    getLoged,
    setLocale,
    getLocale,
    getCustomer,
    setCustomer,
    getCustomPhone,
    setCustomPhone,
    getCartImages,
    setCartImages,
    getOnlySupplier,
    setOnlySupplier
};
